module.exports = __webpack_public_path__ + "img/close.b7120133.svg";